const liberRed = {
    400: '#E63537',
    300: '#EC6468',
    200: '#F6B5BD',
    100: '#FAE2E8',
};
export default liberRed;
